module.exports = __webpack_public_path__ + "img/logo_ico.c642c921.svg";